const mutations = {
    setScreenHeight: (state, h) => {
        state.screenHeight = h
    },
    setScreenWidth: (state, w) => {
        state.screenWidth = w
    },
    setContainerWidth: (state, w) => {
        state.containerWidth = w
    },
    SETROUTERS: (state, payload) => {
        state.routers = payload
    },
    setCurrentUser: (state, user) => {
        state.currentUser = user
    },
    setCurrentWorker: (state, worker) => {
        state.currentWorker = worker
    },
    setCurrentSurgery: (state, currentSurgery) => {
        state.currentSurgery = currentSurgery
    },
    SET_USERCONFIG: (state, userconfigs) => {
        state.userConfigs = userconfigs
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    },
    SET_WORKBAR: (state, workbar) => {
        state.workbar = workbar
    },
    SET_OtherSettingColumn: (state, otherSettingColumn) => {
        state.otherSettingColumn = JSON.stringify(otherSettingColumn)
        window.sessionStorage.setItem(`otherSettingColumn`, JSON.stringify(otherSettingColumn))
    },
    SET_ExtendColumnList: (state, extendColumnList) => {
        state.extendColumnList = JSON.stringify(extendColumnList)
        window.sessionStorage.setItem(`extendColumnList`, JSON.stringify(extendColumnList))
    },
    SET_ADD_WORK_BAR_ING: (state, status) => {
        state.add_work_bar_ing = status
    },
    SET_get_menu_ing: (state, status) => {
        state.get_menu_ing = status
    },
    SET_MENU: (state, menus) => {
        state.menus = menus
    },
    SET_HOSPITAL_WARD: (state, hospitalWard) => {
        state.hospital_ward = hospitalWard
    },
    SET_OPERATION_WARD: (state, opw) => {
        state.operation_ward = opw
    },
    SET_OPERATION_ROOM: (state, room) => {
        state.operation_room = room
    },
    SET_RECOVERY_WARD: (state, ryd) => {
        state.recovery_ward = ryd
    },
    SET_RECOVERY_BED: (state, bed) => {
        state.recovery_bed = bed
    },
    SET_SECTION: (state, section) => {
        state.section = section
    },
    SET_HOSPITAL_WARD_AUTH: (state, hospitalWard) => {
        state.hospital_ward_auth = hospitalWard
    },
    SET_OPERATION_WARD_AUTH: (state, opw) => {
        state.operation_ward_auth = opw
    },
    SET_OPERATION_WARD_AUTH_DISABLED: (state, opw) => {
        state.operation_ward_auth_disabled = opw
    },
    SET_OPERATION_ROOM_AUTH: (state, room) => {
        state.operation_room_auth = room
    },
    SET_RECOVERY_WARD_AUTH: (state, ryd) => {
        state.recovery_ward_auth = ryd
    },
    SET_RECOVERY_BED_AUTH: (state, bed) => {
        state.recovery_bed_auth = bed
    },
    SET_SECTION_AUTH: (state, section) => {
        state.section_auth = section
    },
    SET_Inpatient_Section_AUTH: (state, section) => {
        state.inpatient_section_auth = section
    },
    SET_WARD_AUTH: (state, ward) => {
        state.ward_auth = ward
    },
    SET_ACTIVE_WARD: (state, ward) => {
        state.active_ward = ward
    },
    SET_ACTIVE_HOSPITAL_WARD: (state, ward) => {
        state.active_hospital_ward = ward
    },
    SET_SYS_DOCUMENT_LIST: (state, sysdocumentlist) => {
        state.sys_document_list = sysdocumentlist
    },
    SET_BUSINESS: (state, business) => {
        state.business = business
    },
    SET_SYS_DOCUMENT: (state, sysDocument) => {
        state.sys_document = sysDocument
    },
    SET_LANGUAGES: (state, languages) => {
        state.languages = languages
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js